export class MicroappEpsQuotastFilter{
    general: string;
}